import { Toolbar, ToolbarButton, ToolbarGroup } from "@fluentui/react-components";
import { AddRegular, ArrowClockwise24Regular, DeleteRegular, DismissRegular, EditRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

import { useSelectedCiRelationTypesContext } from "../context/SelectedCiRelationTypesContext";

const CiRelationTypesToolbar = ({ setIsAddOpen, setIsEditOpen, setIsRemoverOpen }) => {
  const { t } = useTranslation();
  const { value: selectedItems, setValue: setSelectedItems } = useSelectedCiRelationTypesContext();
  const queryClient = useQueryClient();

  const handleClickNew = () => setIsAddOpen(true);
  const handleClickEdit = () => setIsEditOpen(true);

  return (
    <Toolbar>
      <ToolbarGroup>
        <ToolbarButton icon={<AddRegular />} aria-label="Add" onClick={handleClickNew}>
          {t("generic.add")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(selectedItems?.length === 1) || selectedItems?.[0]?.tenant_id === null}
          icon={<EditRegular />}
          aria-label="Edit"
          onClick={handleClickEdit}
        >
          {t("generic.edit")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(selectedItems?.length === 1) || selectedItems?.[0]?.tenant_id === null}
          icon={<DeleteRegular />}
          aria-label="Delete"
          onClick={() => setIsRemoverOpen(true)}
        >
          {t("generic.delete")}
        </ToolbarButton>
        <ToolbarButton
          icon={<ArrowClockwise24Regular />}
          onClick={() => queryClient?.invalidateQueries({ queryKey: ["ci_relation_types"] })}
        >
          {t("generic.refresh")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!(selectedItems?.length > 0)}
          icon={<DismissRegular />}
          onClick={() => setSelectedItems([])}
        >
          {t("generic.unselect")}
        </ToolbarButton>
      </ToolbarGroup>
    </Toolbar>
  );
};

export default CiRelationTypesToolbar;
